import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../../Layouts/Sidebar";
import moment from "moment/moment";
import DataParser from "../../../utlits/Dataparser";
import DepartmentServices from "../../../Services/DepartmentServices";
import { Helmet } from "react-helmet";
import StatusBadge from "../../Reuseable/StatusBadge";
import secureLocalStorage from "react-secure-storage";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Departments = () => {
  const navigate = useNavigate();
  const [Departments, setDepartments] = useState([]);
  const [userPermissions, setuserPermissions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const getDepartments = () => {
    setIsLoading(true);
    // const companyId = DataParser.CompanyId();
    const comapnyId = DataParser.CompanyId();
    DepartmentServices.getCompanyDepartment(comapnyId).then((res) => {
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      }
      const dataset = res.data.departments;
      setDepartments(dataset);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getDepartments();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  const handelDelete = (e, item) => {
    e.preventDefault();
    const id = item.id;
    const newData = Departments.filter((el) => el.id !== id);
    setDepartments(newData);
    const companyId = DataParser.CompanyId();
    DepartmentServices.deleteDepartment(id, companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        }
        getDepartments();
      })
      .catch((err) => {});
  };

  const handelEdit = (e, item) => {
    e.preventDefault();
    navigate(`/${DataParser.CompanyIdentifierRole()}/departments/edit`, {
      state: {
        data: item,
      },
    });
  };

  return (
    <>
      <Helmet>
        <title>Departments - Planit</title>
      </Helmet>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">All Departments</h4>
                  <div className="page-title-right">
                    <ol
                      className="breadcrumb"
                      style={{ marginBottom: "10px !important" }}
                    >
                      <li className="breadcrumb-item">
                        <Link
                          to={`/${DataParser.CompanyIdentifierRole()}/home`}
                        >
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {" "}
                        <Link
                          to={`/${DataParser.CompanyIdentifierRole()}/adminsettings`}
                        >
                          Settings
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Departments</li>
                    </ol>
                    {userPermissions.indexOf("departments-create") !== -1 ? (
                      <Link
                        style={{ float: "right" }}
                        to={`/${DataParser.CompanyIdentifierRole()}/departments/create`}
                        className="btn btn-primary waves-effect waves-light"
                      >
                        Create Department
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table mb-0 table-striped">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Creation Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <>
                              <tr>
                                <th scope="row">
                                  <Skeleton style={{ width: "40%" }} />
                                </th>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                              </tr>
                              <tr>
                                <th scope="row">
                                  <Skeleton style={{ width: "40%" }} />
                                </th>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                              </tr>
                              <tr>
                                <th scope="row">
                                  <Skeleton style={{ width: "40%" }} />
                                </th>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                                <td className="tableset">
                                  <Skeleton style={{ width: "40%" }} />
                                </td>
                              </tr>
                            </>
                          ) : (
                            <>
                              {Departments &&
                                Departments.map((item, index) => (
                                  <tr key={item.id}>
                                    <th scope="row">{index + 1}</th>
                                    <td className="tableset">{item.name}</td>
                                    <td className="tableset">
                                      {userPermissions.indexOf(
                                        "departments-edit"
                                      ) !== -1 ? (
                                        <StatusBadge
                                          item={item}
                                          api={
                                            DepartmentServices.updateDepartment
                                          }
                                        />
                                      ) : (
                                        <>
                                          {item.status === "1" ? (
                                            <span className="btn btn-success waves-effect waves-light btn-sm">
                                              Active
                                            </span>
                                          ) : (
                                            <span className="btn btn-danger waves-effect waves-light btn-sm">
                                              Deactive
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td className="tableset">
                                      {moment(item.updated_at).format(
                                        "D/MM/YYYY"
                                      )}
                                    </td>
                                    <td className="tableset">
                                      {userPermissions.indexOf(
                                        "departments-delete"
                                      ) !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handelDelete(e, item)}
                                        >
                                          <i className="uil-trash iconscolor" />
                                        </Link>
                                      ) : (
                                        ""
                                      )}
                                      {userPermissions.indexOf(
                                        "departments-edit"
                                      ) !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handelEdit(e, item)}
                                        >
                                          <i className="uil-pen iconscolor" />
                                        </Link>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Departments;
